import React, { useContext, useEffect } from 'react';
import Lamp from 'assets/svg/lamp';
import { Button } from 'components/commons';
import IconCheck from 'assets/svg/icon-check';
import useReactRouter from 'use-react-router';
import { RouteParams } from 'components/custom-route/custom-route';
import { LoanApplicationContext } from 'containers/context/useGetLoanApplication';
import { useGetLoanQuery } from 'generated/graphql';

import './bndes-welcome.scss';

const BndesWelcome: React.FC = () => {
    const { history, match } = useReactRouter<RouteParams>();
    const { loanApplicationId } = useContext(LoanApplicationContext);

    const {  data, loading } = useGetLoanQuery({
        variables:{
            id:loanApplicationId
        },
        fetchPolicy:"cache-first"
    });

    useEffect(() => {
        if(!loanApplicationId) {
            return null;
        }
    },[loanApplicationId])

    const onClick = async () => {
        const id = match.params.loanApplicationId;

        let url = `/${window.location.search}`;
        if ((id && id !== 'bndes') || (data && data.loanApplication && data.loanApplication.id)) {
            url = `/pedido/${id}/${window.location.search}`;
        }

        history.push(url);
    };

    useEffect(() => {
        hideSteps();
        loadTrustpilotScript();
    }, []);

    const loadTrustpilotScript = () => {
        const script = document.createElement('script');
        script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    }

    const hideSteps = () => {
        // workaround to remove steps, refactory to remove
        const stepClasses = ['desktop-steps', 'desktop-steps-partner', 'mobile-steps-partner', 'mobile-steps'];

        setTimeout(() => {
            stepClasses.forEach(classes => {
                const element = document.getElementsByClassName(classes)[0];
                if (element) {
                    element.remove();

                }
            });
        }, 100);
    }

    return (
        <div className="message-box-container bndes-message-box-container">
            <div className="inner">
                <div className="screen">
                    <div className="bndes-welcome">
                        <div className="welcome">
                            { (data && data.loanApplication && data.loanApplication.borrower.responsibleName) &&
                                <h1 className="text-primary lower-case">
                                    olá, {data.loanApplication.borrower.responsibleName.split(' ')[0]}!
                                    somos a biz
                                </h1>
                            }
                            { (data && (!data.loanApplication || !data.loanApplication.borrower.responsibleName)) &&
                                <h1 className="text-primary lower-case">
                                    olá! somos a biz
                                </h1>
                            }
                            <p className="body-1">empréstimo para empresa rápido,<br/> seguro e online!</p>
                            <p className="subtitle">pra fazer uma análise de crédito <br/>precisamos te conhecer melhor</p>
                            <div className="flex">
                                <Lamp className="mr-3"/>
                                <p className="body-2">Se você já preencheu algumas informações no site do BNDES, é só completar aqui!</p>
                            </div>
                        </div>
                        <div>
                            <div className="bizcap">
                                <div className="box">
                                    <div className="box-content">
                                        <div className="">
                                            <div className="flex flex-row">
                                                <div className="mt-3">
                                                    <IconCheck />
                                            </div>
                                                <div className="text body-2">Empréstimo sem garantias reais. Até R$200 mil, em 24x e juros a partir de 1,99% ao mês.</div>
                                            </div>
                                            <div className="flex flex-row mt-5">
                                                <div className="mt-3">
                                                    <IconCheck />
                                            </div>
                                                <div className="text body-2">Com a Biz, o dinheiro pode cair na conta da sua empresa no mesmo dia.</div>
                                            </div>
                                            <div className="flex flex-row mt-5">
                                                <div className="mt-3">
                                                    <IconCheck />
                                            </div>
                                                <div className="text body-2">
                                                    Financie o seu capital de giro, estoque, expansão ou reforma e mais.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex-1 mt-3 sm-show">
                                <div className="trustpilot-widget" data-locale="pt-BR" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="5aa6c739a707cb00017177eb" data-style-width="100%" data-theme="light">
                                    <a href="https://br.trustpilot.com/review/bizcapital.com.br" target="_blank" rel="noopener">Trustpilot</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer">
                <div className="screen">
                    <div className="footer-content">
                        <div className="button">
                            <Button type="button" variant="primary" label="começar" className="btn" onClick={onClick} disabled={loading}/>
                        </div>
                        <div className="flex-1 mt-3 md-show trustpilot">
                            <div className="trustpilot-widget" data-locale="pt-BR" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="5aa6c739a707cb00017177eb" data-style-height="20px" data-style-width="100%" data-theme="light">
                                <a href="https://br.trustpilot.com/review/bizcapital.com.br" target="_blank" rel="noopener">Trustpilot</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default BndesWelcome;
